<template>
    <div>

        <form class="needs-validation" novalidate>
            <h1>{{$t('seb-title')}}</h1>

            <h2>{{$t('Step 3 of 5: Mailing address for SEB package')}}</h2>

            <p class="mt-4">{{$t('Please provide the mailing address you would like the SEB package to be sent to.')}}</p>

            <fieldset>
                <legend>{{$t('Mailing address')}}</legend>
                <div class="form-row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label for="address">{{$t('Address')}}</label>
                            <input id="address" class="form-control" required v-model="address1" autocomplete="off">
                            <div class="invalid-feedback" v-if="!valid_form">{{$t('mandatory_requirement')}}</div>
                        </div>
                        <div class="form-group">
                            <label for="address2">{{$t('Address 2')}}</label>
                            <input id="address2" aria-describedby="address2HelpBlock" class="form-control" v-model="address2" autocomplete="off">
                            <small id="address2HelpBlock" class="form-text text-muted">
                                {{$t('Enter additional address information such as unit, apartment, suite # or building name.')}}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <div class="form-group">
                            <label for="city">{{$t('City')}}</label>
                            <input id="city" class="form-control" v-model="city" required autocomplete="off">
                            <div class="invalid-feedback" v-if="!valid_form">{{$t('mandatory_requirement')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <div class="form-group">
                            <label for="province">{{$t('Province, state, or region')}}</label>
                            <input id="province" class="form-control" v-model="province" required autocomplete="off">
                            <div class="invalid-feedback" v-if="!valid_form">{{$t('mandatory_requirement')}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 col-6">
                        <div class="form-group">
                            <label for="code">{{$t('Postal or zip code')}}</label>
                            <input id="code" class="form-control" v-model="postal_code" autocomplete="off">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <div class="form-group">
                            <label for="country">{{$t('Country')}}</label>
                            <input id="country" class="form-control" v-model="country" required autocomplete="off">
                            <div class="invalid-feedback" v-if="!valid_form">{{$t('mandatory_requirement')}}</div>
                        </div>
                    </div>
                </div>
            </fieldset>

            <div class="row no-gutters">
                <div class="col"><button class="btn btn-outline-secondary mt-4 float-right" @click="prev_step">{{$t('previous')}}</button></div>
                <div class="col-auto"><button class="btn btn-secondary mt-4 ml-3" @click="next_step">{{$t('next')}}</button></div>
            </div>
        </form>
    </div>
</template>
<script>
    import $ from "jquery";

    export default {
        data() {
            return {
                address1: null,
                address2: null,
                city: null,
                province: null,
                postal_code: null,
                country: null,
            }
        },
        created: function () {
            this.seb_mailing_info = this.$store.getters.SEB_MAILING_INFO;

            if (this.seb_mailing_info.length > 0) {
                let info = this.seb_mailing_info[0];

                this.address1 = info.address1;
                this.address2 = info.address2;
                this.city = info.city;
                this.province = info.province;
                this.postal_code = info.postal_code;
                this.country = info.country;
            }
        },

        computed: {
            valid_address: function () {
                return (this.address1 && this.city && this.province && this.country);
            },
            valid_form: function () {
                return (this.valid_address);
            },
            disabled_button: function () {
                return (!this.valid_address);
            }
        },

        methods: {
            next_step: function () {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();

                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');

                    $(".invalid-feedback").removeClass("invalid-feedback").addClass("invalid");
                });

                if (validation === true) {
                    var seb_mailing_info = {
                        address1: this.address1,
                        address2: this.address2,
                        city: this.city,
                        province: this.province,
                        postal_code: this.postal_code,
                        country: this.country,
                    };
                    //this.$store.commit('update_voter', voter);
                    this.$store.dispatch("SAVE_SEB_MAILING_INFO", seb_mailing_info);

                    this.$router.push({ name: "SealedEnvelopeBallotStep4", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id, registration_id: this.$route.params.registration_id } });
                    //bus.$emit('change-tab', tran('register_vote_three'));
                }
            },
            prev_step: function () {
                this.$router.push({ name: "SealedEnvelopeBallotStep2", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id, registration_id: this.$route.params.registration_id } });
            }
        }

    }
</script>